import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrdonnanceDto } from 'src/app/DTO/ordonnance.dto';
import { formatDate } from '@angular/common';
import { OrdonnanceService } from 'src/app/service/ordonnance.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { EnumEtats } from 'src/app/enum/enum.etat';

@Component({
  selector: 'app-ordonnance-state-modal',
  templateUrl: './ordonnance-state-modal.component.html',
  styleUrls: ['./ordonnance-state-modal.component.scss']
})
export class OrdonnanceStateModalComponent implements OnInit {

  @Input()
  public ordonnance: OrdonnanceDto;

  @Input()
  public etat: string;

  @Output()
  private modalOrdonnanceState: EventEmitter<boolean> = new EventEmitter();

  @Output()
  private needToRefreshList: EventEmitter<boolean> = new EventEmitter();

  sendFormSubject: Subject<void> = new Subject<void>();

  title: string = "";
  etatRejetee: string = EnumEtats.REJETEE;
  etatRejeteeCode: number = -1;

  copyMail: boolean = false;
  message: string = "";
  buttonDisabled: boolean = false;
  ordonnanceDateFormat: string = "";

  constructor(
    protected ordonnanceService: OrdonnanceService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.ordonnanceDateFormat = formatDate(this.ordonnance.date, 'dd/MM/yyyy', 'fr-FR') + " à " + formatDate(this.ordonnance.date, 'HH', 'fr-FR') + 'h' + formatDate(this.ordonnance.date, 'mm', 'fr-FR');

    switch (this.etat) {
      case EnumEtats.TRAITEE:
        this.title = "Ordonnance Traitée";
        this.message = "Votre ordonnance transmise le " +
          this.ordonnanceDateFormat +
          " a été traitée. Nous vous invitons à vous présenter rapidement dans votre pharmacie, muni de votre ordonnance et de votre carte vitale.";
          break;
      case EnumEtats.ENCOURS:
        this.title = "Demande d'Information à Propos de l'Ordonnance";
        this.message = "Nous avons bien reçu votre ordonnance envoyée le " +
          this.ordonnanceDateFormat +
          ", mais nous avons besoin de renseignements complémentaires pour la préparer.  Merci de nous contacter directement par téléphone.";
        break;
      case EnumEtats.REJETEE:
        this.title = "Traitement De l'Ordonnance Impossible";
        break;
    }

    this.modalOrdonnanceState.emit(true);
  }

  closeModal() {
    this.modalOrdonnanceState.emit(false);
  }

  formSended($event: any) {
    this.closeModal();
    this.needToRefreshList.emit(true);
    this.buttonDisabled = false;
  }

  sendForm() {
    this.buttonDisabled = true;
    this.sendFormSubject.next();
  }

  setMessagePhotoIllisible() {
    this.message = "Votre ordonnance transmise le " +
      this.ordonnanceDateFormat +
      " n'a pas pu être traitée car la photo est illisible ou de mauvaise qualité.";
    this.etatRejeteeCode = 0;
  }

  setPhotoNoRelation() {
    this.etatRejeteeCode = 1;
  }

  setMessagePhotoNoRelation() {
    this.message = "Ajouter un motif...";
  }

  rejectWithoutMail() {
    this.ordonnanceService.putOrdonnanceRejetee(this.ordonnance.id, "", false, this.etatRejeteeCode).subscribe(
      data => { this.toastr.success("L'ordonnance a été rejetée."); },
      err => { this.toastr.error("Une erreur est survenue. Merci de réessayer plus tard."); },
      () => { this.formSended(true); }
    );
  }

}
